<script>
    import NauiCheckbox from "../atoms/NauiCheckbox.svelte";
    import NauiState from "../atoms/NauiState.svelte";
    import NauiTag from "../atoms/NauiTag.svelte";
    import NauiButton from "../atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    export let type = 'text';
    export let slug = '';
    export let data = null;
    export let selected = null;
    export let value = null;
    export let options = null;


    function dispatchAction(actionSlug) {
        dispatch('action', {action: actionSlug, slug: slug});
    }

    function setValue() {
        data = value;
    }

    const formatter = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
    });
</script>
<div class="w-100">
    {#if type === 'text'}
        <div class="box">
            {data}
        </div>
    {:else if type === 'checkbox'}
        <NauiCheckbox label="" bind:value={selected}/>

    {:else if type === 'state'}
        {#if data}
            <NauiState code={data.code} label={data.label}/>
        {/if}
    {:else if type === 'tag'}
        {#if data}
            <NauiTag label="{data?.label}"
                     textColor="{data?.textColor}"
                     backColor="{data?.backColor}"
                     borderColor="{data?.borderColor}"/>
        {/if}
    {:else if type === 'date'}
        {#if data}
            <div class="naui-date text-c" style="width:100px">{data}</div>
        {/if}
    {:else if type === 'input'}
        <input class="naui-input w-100"
               type="text"
               on:change={setValue}
               bind:value={value}/>
    {:else if type === 'select'}
        <select class="naui-input w-100">
            {#each options as option}
                <option value={option.value}>{option.label}</option>
            {/each}
        </select>
    {:else if type === 'icon'}
        <i style="font-size: 1.2rem"
           class="{data.iconFamily ? data.iconFamily: 'fal'} fa-{data.icon} {data.color ? data.color : ''}"></i>

    {:else if type === 'actions'}
        <div class="box sx-1">
            {#each data || [] as action}
                {#if action.disabled}
                    <div style="opacity: .35; filter: grayscale(100%); pointer-events: none;">
                        <NauiButton href={action.route} icon="{action.icon}"
                                    iconFamily="{action.iconFamily ? action.iconFamily : 'fal'}"
                                    color="{action.color ? action.color : 'accent'}" disabled/>
                    </div>
                {:else if action.route}
                    <NauiButton href={action.route} icon="{action.icon}"
                                iconFamily="{action.iconFamily ? action.iconFamily : 'fal'}"
                                color="{action.color ? action.color : 'accent'}" download="{action.download}"/>
                {:else}
                    <NauiButton icon="{action.icon}"
                                iconFamily="{action.iconFamily ? action.iconFamily : 'fal'}"
                                color="{action.color ? action.color : 'accent'}"
                                on:click={dispatchAction.bind(this, action.slug)}/>
                {/if}
            {/each}
        </div>

    {:else if type === 'list'}
        {data.map(i => i.label.trim()).join(', ')}
    {:else if type === 'bool'}
        <div class="box">
            {#if data}
                <i class="far fa-check"></i>
            {:else}
                <i class="far fa-times"></i>
            {/if}
        </div>
    {:else if type === 'currency'}
        <div class="box">
            {formatter.format(data)}
        </div>
    {:else}
        {JSON.stringify(data)}
    {/if}
</div>

